import React from "react"

import BreadCrumbs from "./breadCrumbs"
import Canvas from "./canvas"
import Inspector from "./inspector"
import { ModelWrapper } from "./styled"

const Model = () => (
    <ModelWrapper>
        <BreadCrumbs />
        <Canvas />
        <Inspector />
    </ModelWrapper>
)
export default Model
